





















































































import {Component, Vue} from 'vue-property-decorator'
import {TimeEntries} from "@/models/time-entries";
import {TimeEntriesService} from "@/services/time-entries-service";
import {TimeEntriesParams} from "@/models/time-entries-params";
import moment from "moment";

@Component({
    name: "TimeEntriesDetailsList"
})
export default class TimeEntriesDetailsList extends Vue {

    maxDate = new Date();

    fields: any[] = [
        {key: 'actions', label: 'Details'},
        {key: 'user_name', label: 'User', sortable: true},
        {key: 'total_hours', label: 'Total Hours'}
    ];
    items: any[] = [];

    totalRows = 1;
    currentPage = 1;
    perPage = 15;
    pageOptions = [10, 15, 25];
    sortBy = 'user_name';
    sortDesc = true;
    sortDirection = 'desc';
    filter = null;

    time_entries_details: Array<TimeEntries> = new Array<TimeEntries>();

    time_entries_service: TimeEntriesService = new TimeEntriesService();
    time_entries_params: TimeEntriesParams = new TimeEntriesParams();

    created() {
        this.getTimeEntriesDetails();
    }

    mounted() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        // today
        this.maxDate = new Date(today)
        this.maxDate.setMonth(this.maxDate.getMonth())
        this.maxDate.setDate(today.getDate())

        if (localStorage.getItem('userTimeEntries')) {
            localStorage.removeItem('userTimeEntries');
        }
    }

    get cptFieldsTable() {
        if (this.time_entries_details) {
            this.time_entries_details.forEach((timeEntries: TimeEntries) => {
                if (!this.fields.find(f => f.key === timeEntries.activity))
                    this.fields.push({key: timeEntries.activity})
            })
            this.fields.push({key: 'extra_effort', label: 'Extra Effort'});
        }
        return this.fields;
    }

    getTimeEntriesDetails() {
        this.time_entries_details = new Array<TimeEntries>();
        this.time_entries_params = new TimeEntriesParams();
        this.time_entries_service.getTimeEntriesDetails(this.time_entries_params)
            .then((response) => {
                this.time_entries_details = response.data;
                this.mapTimeEntriesDetails()
            })
            .catch((error) => {
                console.log(error);
            })
    }

    mapTimeEntriesDetails() {
        this.items = [];
        if (this.time_entries_details) {
            this.time_entries_details.forEach((timeEntries: TimeEntries) => {
                timeEntries.spent_on = moment(timeEntries.spent_on).format("YYYY-MM-DD");
                if (!this.items.find(u => u.user_name === timeEntries.user_name))
                    this.items.push({user_name: timeEntries.user_name});
                this.items.filter(item => {return item.user_name == timeEntries.user_name})
                .map(item => {
                    if (typeof(item.total_hours) === "undefined")
                        item.total_hours = 0;
                    item.total_hours += timeEntries.hours;
                    item.total_hours = Math.round(item.total_hours * 100) / 100;
                    if (typeof(item.task) === "undefined")
                        item.task = [];
                    if (typeof(item.extra_effort) === "undefined")
                        item.extra_effort = 0;
                    if (timeEntries.activity === "Sviluppo" && !item.task.find((t: string) => t == timeEntries.issue_id)) {
                        item.task.push(timeEntries.issue_id);
                        timeEntries.total_hours > 0 && timeEntries.estimated_hours > 0 && (timeEntries.total_hours - timeEntries.estimated_hours) > 0 ? item.extra_effort += timeEntries.total_hours - timeEntries.estimated_hours : item.extra_effort += 0;
                        item.extra_effort = Math.round(item.extra_effort * 100) / 100;
                    }
                    if (typeof(item[timeEntries.activity]) === "undefined")
                        item[timeEntries.activity] = 0;
                    item[timeEntries.activity] += timeEntries.hours;
                    item[timeEntries.activity] = Math.round(item[timeEntries.activity] * 100) / 100;
                    return item;
                })
            })
            this.totalRows = this.items.length;
        }

        return this.items;
    }

    getUserTimeEntries(user_name: string) {
        const user_time_entries = this.time_entries_details.filter((timeEntries: TimeEntries) => {
            return timeEntries.user_name == user_name
        })
        return user_time_entries.length;
    }

    applyFilters() {
        if (!this.time_entries_params.from || ! this.time_entries_params.to) {
            alert("You must select a date range");
            this.time_entries_params = new TimeEntriesParams();
            return false;
        } else if (this.time_entries_params.from > this.time_entries_params.to) {
            alert("From cannot be greather than To");
            this.time_entries_params = new TimeEntriesParams();
            return false;
        }
        this.time_entries_service.getTimeEntriesDetails(this.time_entries_params)
            .then((response) => {
                this.time_entries_details = response.data;
                this.mapTimeEntriesDetails();
            })
    }

    goToUserTimeEntries(name: string) {
        const userTimeEntries = this.time_entries_details.filter((timeEntries: TimeEntries) => {return timeEntries.user_name === name})
        localStorage.setItem('userTimeEntries', JSON.stringify(userTimeEntries))
        this.$router.push({name: 'userTimeEntries', params: {name: name}})
    }
}
